import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Grid,
  Card,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import payment from "../../Assests/payment.png";
import bg from "../../Assests/bg.png";
import hand from "../../Assests/hand.png";

const IntegrateZutopay = () => {
  const [tabValue, setTabValue] = useState(0);
  const [hoveredCard, setHoveredCard] = useState(null);
  const timeoutRef = useRef(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCardHover = (card) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setHoveredCard(card);
  };

  const handleCardLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredCard(null);
    }, 50);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#f8f9fa" }}>
      {/* Heading Section */}
      <Typography
        variant="h5"
        fontWeight={500}
        mb={1}
        sx={{ fontSize: { xs: "1.1rem", sm: "1.3rem", md: "2rem" } }}
      >
        Integrate Zutopay in minutes and accept payments <br /> securely  from cards,
        UPI, and wallets.
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        mb={3}
        sx={{ fontSize: { xs: "13px", sm: "14px" } }}
      >
        Fast setup, secure transactions, and instant payouts — everything your <br/>
        business needs to start collecting payments.
      </Typography>

      {/* Tabs */}
      <Tabs
        value={tabValue}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          mb: 4,
          "& .MuiTab-root": { fontSize: { xs: "12px", sm: "14px" } },
        }}
        variant={isSmallScreen ? "scrollable" : "standard"}
        scrollButtons={isSmallScreen ? "auto" : false}
      >
        <Tab label="Payment Checkout" />
        <Tab label="Development" />
        <Tab label="Plugins" />
      </Tabs>

      {/* Cards Section */}
      <Grid
        container
        spacing={2}
        sx={{
          flexWrap: isSmallScreen ? "wrap" : "nowrap",
          alignItems: "stretch",
        }}
      >
        {/* Web Checkout Card */}
        <Grid
          item
          size={{ xs: 12, md: hoveredCard === "web" ? 8 : hoveredCard === "mobile" ? 4 : 6 }}
          sx={{ transition: "all 0.3s ease" }}
        >
          <Card
            onMouseEnter={() => handleCardHover("web")}
            onMouseLeave={handleCardLeave}
            sx={{
              background: `url(${bg}) no-repeat center/cover`,
              color: "white",
              borderRadius: 3,
              height: "100%",
              minHeight: 320,
              p: { xs: 2, sm: 3 },
              position: "relative",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "scale(1.02)",
                boxShadow: 3,
                zIndex: 2,
                cursor: "pointer",
              },
            }}
          >
            <CardContent>
              <Box
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems="center"
                height="100%"
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width={{ xs: "100%", sm: "40%" }}
                  mb={{ xs: 2, sm: 0 }}
                >
                  <img
                    src={payment}
                    alt=""
                    style={{
                      width: "100%",
                      height: "auto",
                      maxWidth: "220px",
                    }}
                  />
                </Box>

                <Box
                  width={{ xs: "100%", sm: "60%" }}
                  pl={{ sm: 3 }}
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={1}
                    sx={{ 
                      fontSize: { 
                        xs: hoveredCard === 'mobile' ? '0.9rem' : '1rem', 
                        sm: hoveredCard === 'mobile' ? '1rem' : '1.1rem' 
                      },
                      transition: 'font-size 0.3s ease'
                    }}
                  >
                    Web Checkout
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      opacity: 0.9,
                      fontSize: { 
                        xs: hoveredCard === 'mobile' ? '12px' : '13px', 
                        sm: hoveredCard === 'mobile' ? '10px' : '14px' 
                      },
                      transition: 'font-size 0.3s ease'
                    }}
                  >
                    Fast, secure, and intuitive payment experience on your
                    website. <br />
                    <br />
                    Make payments effortless with Zutopay's web checkout. Our
                    secure and user-friendly interface ensures frictionless
                    transactions, reduces cart abandonment, and boosts your
                    conversion rate.
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Mobile Checkout Card */}
        {/* Mobile Checkout Card */}
<Grid
  item
  size={{ xs: 12, md: hoveredCard === "mobile" ? 8 : hoveredCard === "web" ? 4 : 6 }}
  sx={{ transition: "all 0.3s ease" }}
>
  <Card
    onMouseEnter={() => handleCardHover("mobile")}
    onMouseLeave={handleCardLeave}
    sx={{
      bgcolor: "white",
      borderRadius: 3,
      height: "320px", // fixed height
      minHeight: 320,
      maxHeight: 320,
      border: "1px solid #e0e0e0",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      display: "flex",
      flexDirection: { xs: "column-reverse", sm: "row" },
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        transform: "scale(1.02)",
        boxShadow: 3,
        zIndex: 2,
        cursor: "pointer",
      },
    }}
  >
    {/* Left Image */}
    <Box
      sx={{
        width: { xs: "100%", sm: "40%" },
        height: "100%",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        pl: { sm: 4 },
        "& img": {
          width: "80%",
          height: { xs: "50%", sm: "80%" },
          objectFit: "contain",
        },
      }}
    >
      <img src={hand} alt="Hand holding phone" />
    </Box>

    {/* Right Content */}
    <Box
      sx={{
        width: { xs: "100%", sm: "60%" },
        p: { xs: 2, sm: 3 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: { xs: "center", sm: "flex-start" },
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        mb={1}
        sx={{ 
          fontSize: { 
            xs: hoveredCard === 'web' ? '0.9rem' : '1rem', 
            sm: hoveredCard === 'web' ? '1rem' : '1.1rem' 
          },
          transition: 'font-size 0.3s ease'
        }}
      >
        Mobile Checkout
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ 
          fontSize: { 
            xs: hoveredCard === 'web' ? '12px' : '13px', 
            sm: hoveredCard === 'web' ? '13px' : '14px' 
          },
          transition: 'font-size 0.3s ease'
        }}
      >
        Experience a smooth and secure payment process from your mobile device.
      </Typography>
    </Box>
  </Card>
</Grid>

      </Grid>
    </Box>
  );
};

export default IntegrateZutopay;
